import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-qr-code',
  template: '<canvas #qrCodeCanvas class="qr-code-component"></canvas>',
  styleUrls: ['./qr-code.component.scss']
})
export class QrCodeComponent implements OnInit {

  /**
   * Canvas object
   *
   * @type {ElementRef<HTMLCanvasElement>}
   * @memberof QrCodeComponent
   */
  @ViewChild('qrCodeCanvas') private canvas: ElementRef<HTMLCanvasElement>;

  /**
   * Url to encode in QR-Code
   *
   * @type {string}
   * @memberof QrCodeComponent
   */
  @Input() url: string;

  constructor() { }

  ngOnInit() {
    // create canvas
    QRCode.toCanvas(this.canvas.nativeElement, this.url, function (error) {
      if (error) {
        console.error(error);
      }
    });
  }

}
